// Video utility functions for better video handling
export const VideoUtils = {
  // Check if video file is accessible
  checkVideoAccessibility: async (src) => {
    try {
      const response = await fetch(src, { method: 'HEAD' });
      return {
        accessible: response.ok,
        status: response.status,
        contentType: response.headers.get('content-type'),
        contentLength: response.headers.get('content-length')
      };
    } catch (error) {
      return {
        accessible: false,
        error: error.message
      };
    }
  },

  // Get video file size in MB
  formatFileSize: (bytes) => {
    if (!bytes) return 'Unknown size';
    const mb = bytes / (1024 * 1024);
    return `${mb.toFixed(1)} MB`;
  },

  // Check if user's connection can handle the video
  canHandleVideo: (videoSize, connectionSpeed) => {
    if (!videoSize || !connectionSpeed) return true;
    
    // Rough estimation: video should be loadable in 30 seconds
    const maxSize = connectionSpeed * 30; // MB
    return videoSize <= maxSize;
  },

  // Get optimal video quality based on connection
  getOptimalQuality: (connectionInfo) => {
    if (!connectionInfo) return 'auto';
    
    if (connectionInfo.effectiveType === '4g' && connectionInfo.downlink > 10) {
      return 'high';
    } else if (connectionInfo.effectiveType === '3g' || connectionInfo.downlink < 2) {
      return 'low';
    }
    return 'medium';
  },

  // Preload video metadata
  preloadVideoMetadata: (src) => {
    return new Promise((resolve, reject) => {
      const video = document.createElement('video');
      video.preload = 'metadata';
      video.src = src;
      
      video.onloadedmetadata = () => {
        resolve({
          duration: video.duration,
          videoWidth: video.videoWidth,
          videoHeight: video.videoHeight
        });
      };
      
      video.onerror = (e) => {
        reject(e);
      };
    });
  }
};

export default VideoUtils;
